<template>
    <v-card>
        <v-overlay :value="loading" z-index="300">
            <v-progress-circular indeterminate></v-progress-circular>
        </v-overlay>

        <!-- Forms | Actions | Filters | Search -->
        <v-card-title>
            <v-layout align-center justify-space-between row fill-height>
                <!-- Form | Actions -->
                <v-flex xs12 sm12 md5 lg5 xl5>
                    <!-- Form -->
                    <v-dialog 
                        v-model="dialog" 
                        :max-width="`${maxWidthForm}%`"
                        persistent
                        >
                        <v-spacer></v-spacer>

                        <template v-slot:activator="{ on }">
                            <v-btn 
                                v-on="on"
                                color="primary" dark class="mx-2"
                                v-if="!disableNewItem" 
                                >Novo Item</v-btn>
                        </template>
                        <v-card ref="form">
                            <v-card-title :class="formColor">
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex 
                                            v-for="(input, index) in inputs" 
                                            :key="index" 
                                            :class="input.class" 
                                            >

                                            <!-- Upload -->
                                            <v-file-input
                                                v-if="input.vType === 'v-file-input'"
                                                v-model="itemLoaded[input.vModel]"
                                                :label="input.label"
                                                :multiple="input.multiple"
                                                :placeholder="input.placeholder"
                                                color="indigo accent-4"
                                                counter
                                                prepend-icon="mdi-paperclip"
                                                :show-size="1000"
                                            >
                                                <!-- <template v-slot:selection="{ index, text }">
                                                <v-chip
                                                    v-if="index < 2"
                                                    color="indigo accent-4"
                                                    dark
                                                    label
                                                    small
                                                >
                                                    {{ text }}
                                                </v-chip>

                                                <span
                                                    v-else-if="index === 2"
                                                    class="overline grey--text text--darken-3 mx-2"
                                                >
                                                    +{{ itemLoaded[input.vModel].length - 2 }} Arquivo(s)
                                                </span>
                                                </template> -->
                                            </v-file-input>

                                            <!-- Data Picker -->
                                            <v-menu 
                                                v-else-if="input.vType === 'v-menu'"
                                                v-model="vMenu[index]"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                                :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                                >
                                                
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-if="input.objectParent"
                                                        :label="input.label"
                                                        :value="itemLoaded[input.objectParent][input.vModel] | datePlusWeek"
                                                        v-on="on"
                                                        clearable
                                                        prepend-icon="event"
                                                        readonly
                                                        :required="input.required"
                                                        :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                                        :mask="input.mask"
                                                    >
                                                    </v-text-field>
                                                    <v-text-field
                                                        v-else
                                                        :label="input.label"
                                                        :value="itemLoaded[input.vModel] | datePlusWeek"
                                                        v-on="on"
                                                        clearable
                                                        prepend-icon="event"
                                                        readonly
                                                        :required="input.required"
                                                        :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                                        :mask="input.mask"
                                                    >
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker
                                                    v-if="input.objectParent"
                                                    locale="pt-br"
                                                    v-model="itemLoaded[input.objectParent][input.vModel]"
                                                    @change="vMenu[index] = false"
                                                    :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                                >
                                                </v-date-picker>
                                                <v-date-picker
                                                    v-else
                                                    locale="pt-br"
                                                    v-model="itemLoaded[input.vModel]"
                                                    @change="vMenu[index] = false"
                                                    :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                            
                                            <!-- Table -->
                                            <Table 
                                                v-else-if="input.vType === 'v-data-table'"
                                                :headers="input.headers"
                                                :subHeaders="input.subHeaders"
                                                :singleExpand="input.singleExpand"
                                                :items="itemLoaded[input.items]"
                                                :mask="input.mask"
                                                >  
                                            </Table>

                                            <!-- Tree View -->
                                            <v-treeview 
                                                v-else-if="input.vType === 'v-treeview'"
                                                v-model="itemLoaded[input.vModel]"
                                                :items="minorRecords(input.items, input.itemProp)"
                                                :active.sync="input.activeSync"
                                                :load-children="input.loadChildren"
                                                :open="input.open"
                                                :item-key="input.itemKey"
                                                :activatable="input.activatable"
                                                :active-class="input.activeClass"
                                                :open-on-click="input.openOnClick"
                                                :transition="input.transition"
                                                :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                            >
                                                <template v-slot:prepend="{ item, open }">
                                                    <v-icon>
                                                        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                                    </v-icon>
                                                </template>
                                            </v-treeview>
                                            
                                            <!-- Parent Array -->
                                            <component 
                                                v-else-if="input.arrayParent"
                                                v-bind:is="input.vType" 
                                                v-model="itemLoaded[input.arrayParent][itemLoaded[input.arrayParent].length-1][input.vModel]"
                                                :label="input.label"
                                                :key="input.key"
                                                :headers="input.headers"
                                                :items="minorRecords(input.items, input.itemProp)"
                                                :item-text="input.itemText"
                                                :item-value="input.itemValue"
                                                :search="input.search"
                                                :hint="input.hint"
                                                :persistent-hint="input.persistentHint"
                                                :multiple="input.multiple"
                                                :chips="input.chips"
                                                :smallChips="input.smallChips"
                                                :color="input.color"
                                                :hideDetails="input.hideDetails"
                                                :deletable-chips="input.deletableChips"
                                                :return-object="input.returnObject"
                                                :single-line="input.singleLine"
                                                :clearable="input.clearable"
                                                :prepend-icon="input.prependIcon"
                                                :prefix="input.prefix"
                                                :suffix="input.suffix"
                                                :required="input.required"
                                                :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                                :mask="input.mask"
                                                :class="input.class">
                                            </component>

                                            <!-- Parent Object -->
                                            <component 
                                                v-else-if="input.objectParent"
                                                v-bind:is="input.vType" 
                                                v-model="itemLoaded[input.objectParent][input.vModel]"
                                                :label="input.label"
                                                :key="input.key"
                                                :headers="input.headers"
                                                :items="minorRecords(input.items, input.itemProp)"
                                                :item-text="input.itemText"
                                                :item-value="input.itemValue"
                                                :search="input.search"
                                                :hint="input.hint"
                                                :persistent-hint="input.persistentHint"
                                                :multiple="input.multiple"
                                                :chips="input.chips"
                                                :smallChips="input.smallChips"
                                                :color="input.color"
                                                :hideDetails="input.hideDetails"
                                                :deletable-chips="input.deletableChips"
                                                :return-object="input.returnObject"
                                                :single-line="input.singleLine"
                                                :clearable="input.clearable"
                                                :prepend-icon="input.prependIcon"
                                                :prefix="input.prefix"
                                                :suffix="input.suffix"
                                                :required="input.required"
                                                :mask="input.mask"
                                                :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                                :class="input.class">
                                            </component>
                                            
                                            <!-- Default -->
                                            <component 
                                                v-else
                                                v-bind:is="input.vType" 
                                                v-model="itemLoaded[input.vModel]"
                                                :label="input.label"
                                                :key="input.key"
                                                :headers="input.headers"
                                                :items="minorRecords(input.items, input.itemProp)"
                                                :item-text="input.itemText"
                                                :item-value="input.itemValue"
                                                :search="input.search"
                                                :hint="input.hint"
                                                :persistent-hint="input.persistentHint"
                                                :multiple="input.multiple"
                                                :chips="input.chips"
                                                :smallChips="input.smallChips"
                                                :color="input.color"
                                                :hideDetails="input.hideDetails"
                                                :deletable-chips="input.deletableChips"
                                                :return-object="input.returnObject"
                                                :single-line="input.singleLine"
                                                :clearable="input.clearable"
                                                :prepend-icon="input.prependIcon"
                                                :prefix="input.prefix"
                                                :suffix="input.suffix"
                                                :append-icon="input.appendIcon"
                                                :rules="input.rules"
                                                :type="input.type"
                                                :required="input.required"
                                                :mask="input.mask"
                                                :dense="input.dense"
                                                :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                                :class="input.class">
                                                {{input.content}}
                                            </component>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                
                                <v-btn 
                                    text
                                    color="grey"
                                    @click="close">{{ (mode === 'view') ? 'Fechar' : 'Cancelar' }}</v-btn>
                                
                                <v-btn 
                                    text
                                    color="success" 
                                    v-if="mode === 'save' || mode === 'edit'" 
                                    @click="save">Salvar</v-btn>

                                <v-btn 
                                    text
                                    color="error" 
                                    v-if="mode === 'remove'" 
                                    @click="remove">Excluir</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <!-- Importer -->
                    <v-dialog 
                        v-model="dialogImport" 
                        v-if="enableImport"
                        :max-width="`${maxWidthFormImport}%`"
                        >
                        <v-spacer></v-spacer>

                        <template v-slot:activator="{ on }">
                            <v-btn 
                                v-on="on"
                                color="primary" dark class="mx-2"
                                v-if="!disableNewItem" 
                                >Importar</v-btn>
                        </template>
                        <v-card ref="form">
                            <v-card-title :class="formColor">
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout row wrap justify-space-between>
                                        <v-flex 
                                            v-for="(input, index) in inputsImport" 
                                            :key="index" 
                                            :class="input.class" 
                                            >
                                            
                                            <!-- Data Picker -->
                                            <v-menu v-if="input.vType === 'v-menu'"
                                                v-model="vMenu[index]"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px">
                                                
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        :label="input.label"
                                                        :value="itemLoaded[input.vModel] | datePlusWeek"
                                                        v-on="on"
                                                        clearable
                                                        prepend-icon="event"
                                                        readonly
                                                        :required="input.required"
                                                        :mask="input.mask"
                                                    >
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker
                                                    locale="pt-br"
                                                    v-model="itemLoaded[input.vModel]"
                                                    @change="vMenu[index] = false"
                                                >
                                                </v-date-picker>
                                            </v-menu>
                                            
                                            <!-- Table -->
                                            <Table v-else-if="input.vType === 'v-data-table'"
                                                :headers="input.headers"
                                                :subHeaders="input.subHeaders"
                                                :singleExpand="input.singleExpand"
                                                :items="itemLoaded[input.items]"
                                                :mask="input.mask"
                                                >  
                                            </Table>

                                            <!-- Tree View -->
                                            <v-treeview v-else-if="input.vType === 'v-treeview'"
                                                v-model="itemLoaded[input.vModel]"
                                                :items="minorRecords(input.items, input.itemProp)"
                                                :active.sync="input.activeSync"
                                                :load-children="input.loadChildren"
                                                :open="input.open"
                                                :item-key="input.itemKey"
                                                :activatable="input.activatable"
                                                :active-class="input.activeClass"
                                                :open-on-click="input.openOnClick"
                                                :transition="input.transition"
                                            >
                                                <template v-slot:prepend="{ item, open }">
                                                    <v-icon>
                                                        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                                    </v-icon>
                                                </template>
                                            </v-treeview>
                                            
                                            <!-- Parent Array -->
                                            <component v-else-if="input.arrayParent"
                                                v-bind:is="input.vType" 
                                                v-model="itemLoaded[input.arrayParent][itemLoaded[input.arrayParent].length-1][input.vModel]"
                                                :label="input.label"
                                                :key="input.key"
                                                :headers="input.headers"
                                                :items="minorRecords(input.items, input.itemProp)"
                                                :item-text="input.itemText"
                                                :item-value="input.itemValue"
                                                :search="input.search"
                                                :hint="input.hint"
                                                :persistent-hint="input.persistentHint"
                                                :multiple="input.multiple"
                                                :chips="input.chips"
                                                :deletable-chips="input.deletableChips"
                                                :return-object="input.returnObject"
                                                :single-line="input.singleLine"
                                                :clearable="input.clearable"
                                                :prepend-icon="input.prependIcon"
                                                :prefix="input.prefix"
                                                :suffix="input.suffix"
                                                :required="input.required"
                                                :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                                :mask="input.mask"
                                                :class="input.class">
                                            </component>

                                            <!-- Parent Object -->
                                            <component 
                                                v-else-if="input.objectParent"
                                                v-bind:is="input.vType" 
                                                v-model="itemLoaded[input.objectParent][input.vModel]"
                                                :label="input.label"
                                                :key="input.key"
                                                :headers="input.headers"
                                                :items="minorRecords(input.items, input.itemProp)"
                                                :item-text="input.itemText"
                                                :item-value="input.itemValue"
                                                :search="input.search"
                                                :hint="input.hint"
                                                :persistent-hint="input.persistentHint"
                                                :multiple="input.multiple"
                                                :chips="input.chips"
                                                :smallChips="input.smallChips"
                                                :color="input.color"
                                                :hideDetails="input.hideDetails"
                                                :deletable-chips="input.deletableChips"
                                                :return-object="input.returnObject"
                                                :single-line="input.singleLine"
                                                :clearable="input.clearable"
                                                :prepend-icon="input.prependIcon"
                                                :prefix="input.prefix"
                                                :suffix="input.suffix"
                                                :required="input.required"
                                                :mask="input.mask"
                                                :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                                :class="input.class">
                                            </component>
                                            
                                            <!-- Default -->
                                            <component v-else
                                                v-bind:is="input.vType" 
                                                v-model="itemLoaded[input.vModel]"
                                                :label="input.label"
                                                :key="input.key"
                                                :headers="input.headers"
                                                :items="minorRecords(input.items, input.itemProp)"
                                                :item-text="input.itemText"
                                                :item-value="input.itemValue"
                                                :search="input.search"
                                                :hint="input.hint"
                                                :persistent-hint="input.persistentHint"
                                                :multiple="input.multiple"
                                                :chips="input.chips"
                                                :deletable-chips="input.deletableChips"
                                                :return-object="input.returnObject"
                                                :single-line="input.singleLine"
                                                :clearable="input.clearable"
                                                :prepend-icon="input.prependIcon"
                                                :prefix="input.prefix"
                                                :suffix="input.suffix"
                                                :append-icon="input.appendIcon"
                                                :rules="input.rules"
                                                :type="input.type"
                                                :required="input.required"
                                                :disabled="mode === 'remove' || mode === 'view' || input.disabled"
                                                :mask="input.mask"
                                                :class="input.class">
                                            </component>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                
                                <v-btn 
                                    text
                                    color="grey"
                                    @click="closeImport">Cancelar</v-btn>
                                
                                <v-btn 
                                    text
                                    color="success" 
                                    @click="importRecords">Importar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    
                    <!-- Print Button -->
                    <PrintBtn
                        v-if="enablePrint" 
                        :scope="scope"
                        :subScope="subScope"
                        class="mx-2"
                        >
                    </PrintBtn>
                    <!-- Export PDF -->
                    <v-btn 
                        slot="activator" 
                        color="primary" 
                        class="mb-2 mr-2"
                        fab 
                        outlined 
                        small
                        @click.native="exportPdf(optionExportPdf)"
                        >
                        <v-icon dark>mdi-file-pdf</v-icon>
                    </v-btn>
                    <!-- Export CSV -->
                    <v-btn 
                        slot="activator" 
                        color="primary" 
                        class="mb-2 mr-2"
                        fab 
                        outlined 
                        small
                        @click.native="exportCsv(records)"
                        >
                        <v-icon dark>mdi-file-excel</v-icon>
                    </v-btn>
                
                </v-flex>

                <!-- Filters | Search -->
                <v-flex xs12 sm12 md6 lg6 xl6>
                    <v-layout>
                        <!-- Filters -->
                        <v-flex 
                            v-for="(n, i) in filters"
                            :key="n.value"
                            xs12 sm12 md12 lg12 xl12 mr-2>
                            <v-select
                                :items="loadFilter(n.value)"
                                :label="n.text"
                                chips
                                deletable-chips
                                multiple
                                v-model="filtersModels[i]"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index === 0">
                                        <span>{{ item }}</span>
                                    </v-chip>
                                    <span v-if="index === 1" class="grey--text caption">
                                        (+{{ filtersModels[i].length - 1 }} outros)
                                    </span>
                                </template>
                            </v-select>
                        </v-flex>

                        <!-- Search --> 
                        <v-flex xs12 sm12 md12 lg12 xl12>
                            <v-text-field 
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Buscar"
                                hide-details>
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-title>

        <!-- Component Header -->
        <ComponentHeader
            v-if="componentHeader"
            :scope="scope"
            >
        </ComponentHeader>

        <!-- Table -->
        <v-data-table
            :headers="headers"
            :items="records"
            item-key="_id"
            :loading="!tableLoaded"
            :expanded.sync="expanded"
            loading-text="Carregando... Por favor aguarde"
            :key="tableKey"
            :search="search"
            class="elevation-1">
         
            <!-- Items -->
            <template v-slot:item="props">
                <tr
                v-if="eval(validationItem, props.item)" 
                >   
                    <td v-for="header in headers.slice(0, headers.length)" 
                        :key="header.value"
                        :class="header.options.tdClass"
                        :nowrap="(header.value === 'actions' || header.value === '_actions') || header.options.nowrap"
                        align-self="center"
                        >

                        <template v-if="(header.value === 'actions' || header.value === '_actions')"> 
                            <v-icon 
                                v-if="props.item.hasOwnProperty('childrens')"
                                @click="expanded = (expanded.includes(props.item)) ? [] : [props.item]"
                                small color="green darken-2" class="mr-2">
                                mdi-arrow-expand-vertical
                            </v-icon>
                            <v-icon v-if="header.options.load === true" small color="indigo" class="mr-2" @click="loadNext(props.item)">
                                mdi-ray-start-arrow
                            </v-icon>
                            <v-icon v-if="header.options.view !== false" small color="green darken-2" class="mr-2" @click="loadItem(props.item, 'view')">
                                mdi-eye
                            </v-icon>
                            <v-icon v-if="header.options.edit !== false && (!props.item.hasOwnProperty('childrens') || scope !== 'diagnosisById')" small color="yellow darken-3" class="mr-2" @click="loadItem(props.item, 'edit')">
                                mdi-pencil
                            </v-icon>
                            <v-icon v-if="header.options.delete !== false" small color="red darken-4" @click="loadItem(props.item, 'remove')">
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-if="header.options.vChip">  
                            <v-chip 
                                v-for="item in dynamicNestedObjects(props.item, header.value, header.options)" 
                                :key="item"
                                color="primary"
                                class="ma-1"
                                dark
                                >
                                    {{ item }}
                            </v-chip>
                        </template>
                        <template v-else-if="header.options.vGantt">  
                            <v-layout>
                                <v-flex
                                    v-for="(item, index) in ganttObject(props.item)" 
                                    :key="index"
                                >
                                    <v-card dark flat max-height="40" class="no-rounded" :color="item.color">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-card-text v-on="on" />
                                            </template>
                                            <span>{{item.text}}</span>
                                        </v-tooltip>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </template>
                        <template v-else-if="header.options.component">
                            <component 
                            v-bind:is="header.options.component.vType" 
                            :rotate="header.options.component.rotate"
                            :size="header.options.component.size"
                            :width="header.options.component.width"
                            :height="header.options.component.height"
                            :value="dynamicNestedObjects(props.item, header.value, header.options)"
                            :color="performanceColor(dynamicNestedObjects(props.item, header.value, header.options))"
                            :style="header.options.component.style"
                            dark
                            >
                            {{ dynamicNestedObjects(props.item, header.value, header.options) }}%
                            </component>
                        </template>
                        <template v-else-if="header.options.switch"> 
                            <v-switch
                                v-model="props.item[header.value]"
                                :color="header.options.switch.color"
                                :value="dynamicNestedObjects(props.item, header.value, header.options)"
                                @change="editInlineItem(props.item, 'edit')"
                                hide-details
                            ></v-switch>
                        </template>
                        <template v-else-if="header.secValue"> 
                            {{ dynamicNestedObjects(props.item, header.value, header.options) }}/
                            {{ dynamicNestedObjects(props.item, header.secValue, header.options) }}
                        </template>
                        <template v-else-if="header.options.link"> 
                            <v-btn outlined x-small fab color="indigo"
                                v-clipboard:copy="dynamicNestedObjects(props.item, header.value, header.options)"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError"
                                >

                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                        </template>
                        <template v-else> 
                            <template v-if="header.options.copy"> 
                                <v-btn outlined x-small fab color="indigo" class="mr-1"
                                    v-clipboard:copy="dynamicNestedObjects(props.item, header.value, {})"
                                    v-clipboard:success="onCopy"
                                    v-clipboard:error="onError"
                                    >

                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                            </template>
                            {{header.prefix}} {{ dynamicNestedObjects(props.item, header.value, header.options) }} {{header.suffix}}
                        </template>
                    </td>
                </tr>
            </template>
            
            <!-- Expand item -->
            <template v-slot:expanded-item="{item, headers}">
                <tr v-for="subItem in item.childrens" :key="subItem.name">
                    <td v-for="(subHeader, ix) in subHeaders.slice(0, subHeaders.length)" 
                        :key="subHeader.value"
                        :class="subHeader.options.tdClass">

                        <template v-if="ix === 0">
                            <v-icon small color="black" class="mr-2">
                                mdi-subdirectory-arrow-right
                            </v-icon>
                        </template>                        
                        <template v-if="subHeader.value === 'actions'"> 
                            <v-icon v-if="subHeader.options.view !== false" small color="green darken-2" class="mr-2" @click="loadItem(subItem, 'view')">
                                mdi-eye
                            </v-icon>
                            <v-icon v-if="subHeader.options.edit !== false" small color="yellow darken-3" class="mr-2" @click="loadItem(subItem, 'edit')">
                                mdi-pencil
                            </v-icon>
                            <v-icon v-if="subHeader.options.delete !== false" small color="red darken-4" @click="loadItem(subItem, 'remove')">
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-if="subHeader.options.vChip">  
                            <v-chip 
                                v-for="item in dynamicNestedObjects(subItem, subHeader.value, subHeader.options)" 
                                :key="item"
                                color="primary"
                                dark
                                >
                                    {{ item }}
                            </v-chip>
                        </template>
                        <template v-else-if="subHeader.options.component">
                            <component 
                            v-bind:is="subHeader.options.component.vType" 
                            :rotate="subHeader.options.component.rotate"
                            :size="subHeader.options.component.size"
                            :width="subHeader.options.component.width"
                            :height="subHeader.options.component.height"
                            :value="dynamicNestedObjects(subItem, subHeader.value, subHeader.options)"
                            :color="performanceColor(dynamicNestedObjects(subItem, subHeader.value, subHeader.options))"
                            :style="subHeader.options.component.style"
                            dark
                            >
                            {{ dynamicNestedObjects(subItem, subHeader.value, subHeader.options) }}%
                            </component>
                        </template>
                        <template v-else-if="subHeader.secValue"> 
                            {{ dynamicNestedObjects(subItem, subHeader.value, subHeader.options) }}/
                            {{ dynamicNestedObjects(subItem, subHeader.secValue, subHeader.options) }}
                        </template>
                        <template v-else> 
                            {{ dynamicNestedObjects(subItem, subHeader.value, subHeader.options) }}
                        </template>
                    </td>
                </tr>
            </template>
        
            <!-- No Data -->
            <template v-slot:no-data>
                <v-alert :value="true" type="error" icon="mdi-alert-outline" class="mt-3">
                    Desculpe, nenhum registro encontrado :(
                </v-alert>
            </template>

            <!-- No Results  -->
            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="mdi-alert-outline" class="mt-3">
                    Seu filtro por "{{ search }}" não retornou registros.
                </v-alert>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import moment from '@/config/moment'
import Table from '../register/Table'
import ComponentHeader from '../register/ComponentHeader'
import PrintBtn from '../register/PrintBtn'
import Vue from 'vue'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { showSuccess, showError, showLoading, cloneDeep } from '@/global'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('registers')

export default {
    name: 'Default',
    components: { Table, ComponentHeader, PrintBtn },
    props: {
        componentHeader: {
            type: Boolean,
            default: false
        },
        disableNewItem: {
            type: Boolean,
            Default: false
        },
        enableImport: {
            type: Boolean,
            Default: false
        },
        enablePrint: {
            type: Boolean,
            Default: false
        },
        pathPrintPage: {
            type: String,
            Default: ''
        },
        title: String,
        scope: String,
        subScope: String,
        path: String,
        segment: {
            type: String,
            default: ''
        },
        query: {
            type: String,
            default: ''
        },
        arrayChilds: Array,
        minorScopes: Array,
        headers: Array,
        validationItem: {
            type: String,
            default: 'true'
        },
        subHeaders: Array,
        singleExpand: {
            type: Boolean,
            default: true
        },
        maxWidthForm: {
            type: Number,
            default: 80
        },
        maxWidthFormImport: {
            type: Number,
            default: 40
        },
        inputs: Array,
        inputsImport: Array,
        itemModel: {
            type: Object,
            default: () => ({
                // indicator:  {},
                // budget: {},
                // period: {}
            })
        },
        optionExportPdf: {
            type: Object,
            default: () => ({
            })
        }
    },
    data: function() {
        return {
            dialog: false,
            dialogImport: false,
            search: '',
            expanded: [],
            filtersModels: [],
            tableLoaded: false,
            tableKey: 0,
            itemLoaded: {},
      		formTitle: '',
			formColor: '',
            mode: 'save',
            vMenu: [],
        }
    },
    computed: {
		...mapState(['tabActived', 'loading']),
        ...mapGetters(['getRecords', 'tabActived', 'loading', 'log']),
        
        tabActived: {
			get () {
				return this.$store.state.registers.tabActived
			},
			set (value) {
				this.$store.commit('registers/setTabActived', value)
			}
        },
         loading: {
			get () {
				return this.$store.state.registers.loading
			},
			set (value) {
				this.$store.commit('registers/setLoading', value)
			}
		},
		records: {
            get () {
                let records = this.getRecords(this.scope)
                if (this.arrayChilds && Object.keys(records).length > 0) {
                    for (var x = 0; x < this.arrayChilds.length; x++) {
                        var element = this.arrayChilds[x]
                        records = (Array.isArray(records)) ? records[records.length - 1][element] : records[element]
                    }
                } 

                return (Array.isArray(records)) ? records : []
			},
			set (payload) {
                this.$store.commit('registers/setRecords', { scope: this.scope, payload })
			}
        },
        filters() {
            const filters = this.headers.filter(x => x.filterable === true)
            this.filtersModels = Array(filters.length)
            filters.forEach((el, ix) => {
                const index = this.headers.findIndex(x => x.value === el.value)
                this.headers[index].filter = value => {
                    if (!this.filtersModels[ix]) return true
                    if (this.filtersModels[ix].length === 0) return true
                    return this.filtersModels[ix].find(n => n === value)
                }
            })
            return filters
        }
	},
    watch: {
        tabActived (newValue, oldValue) {
            if (oldValue === 0 && newValue === 1) {
                this.rerenderTable()
            }
        },
        filtersModels: {
            handler: function () {
                // console.log(this.filtersModels)
            },
			deep: true
        },
        dialog (val) {
            val || this.close('dialog')
        },
        dialogImport (val) {
            val || this.close('dialogImport')
        },
        itemLoaded: {
			handler: function () {
                // RETIREI E ADICIONE NO SALVAMENTO
                // if (this.itemLoaded.hasOwnProperty('questions')) {
                //     this.itemLoaded.score = this.itemLoaded.questions.map((x) => { return x.response.score.value }).reduce( (accum, curr) => accum + curr );
                //     this.itemLoaded.performance = Math.round(this.itemLoaded.score/this.itemLoaded.scoreMax*100)	
				// }
			},
			deep: true
        },
        record: {
			handler: function () {
                // console.log(this.records)
			},
			deep: true
		}
    },
    methods: {
        ...mapActions(['loadRecords','saveRecords', 'removeRecords', 'updateScore']),
        
        initialize() {
            this.loadRecords({ scope: this.scope, path: this.path, segment: this.segment, query: this.query }).then(() => { this.tableLoaded = true }).catch(() => {})
            for (var scope in this.minorScopes) {
                this.loadRecords({ scope: this.minorScopes[scope], path: this.minorScopes[scope] }).catch(() => {})
            }
        },

        minorRecords(scope, prop) {
            if (!scope) {
                return 
            }
            const record = this.getRecords(scope)
            return (prop) ? record[prop] : record
        },

        loadFilter(scope) {
            if (!scope) { return }

            scope = scope.split('.')
            // Alteração para quando nome da coluna não condiz exatamente com o GET da API
            switch (scope[0]) {
                case 'branch':
                    scope[0] = 'branches'
                    break;
            }
        
            let filter = this.getRecords(scope[0])
            if (typeof filter === 'undefined' || filter.length < 1) { return [] } 

        	for (let i = 1; i < scope.length; i++) {
                const element = scope[i];
                filter = filter.map((x) => { return x[element] })
            }
            // console.log(filter)
            return [...filter] 
        },

        rerenderTable () {
			this.tableKey += 1;  
		},
		
		reset() {
            this.mode = 'save'
            this.itemLoaded = cloneDeep(this.itemModel)
            this.formProperty()
		},

        loadItem (item, mode = 'save') {
            this.mode = mode
            item = this.formatDate(item)
            this.itemLoaded = Object.assign({}, item)
            this.formProperty()
			this.dialog = true
        },

        formatDate(item) {
            const regex = new RegExp('\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}.\\d{3}Z');

            for (var key in item) {
                const el = item[key]
                if(typeof el === 'object') {
                    for (var key2 in el) {
                        const el2 = el[key2]
                        if (regex.test(el2)) {
                            item[key][key2] = el2.substr(0, 10)
                        }
                    }
                } else if (regex.test(el)) {
                    item[key] = el.substr(0, 10)
                }
            }

            return item
        },
        
        editInlineItem (item, mode) {
            this.loading = true
            showLoading() 
            this.saveRecords({ scope: this.scope, arrayChilds: this.arrayChilds, path: this.path, payload: item })
                .then((response) => { 
                    if (this.scope === 'diagnosis') {
                        this.loadRecords({ scope: 'diagnosisById', path: 'diagnosis', segment: response.data._id })
                            .then(() => {}).catch(() => {})
                    } else if (this.scope === 'planning') {
                        this.loadRecords({ scope: 'planningById', path: 'planning', segment: response.data._id })
                            .then(() => {}).catch(() => {})
                    } else if (this.scope === 'logs') {
                        this.loadRecords({ scope: 'log', path: 'logs', segment: response.data._id })
                            .then(() => {}).catch(() => {})
                    }

                    showSuccess(response, this.scope, mode) 
                    this.close()
                    this.rerenderTable() 
                    this.loading = false
                })
                .catch((e) => { showError(e); this.loading = false })
        },

        loadNext(item) {
            let scope, path, segment, childrenId, tabActived = ''
            switch (this.scope) {
                case 'diagnosis':
                    {
                        scope = 'diagnosisById'
                        path = 'diagnosis'
                        segment = item._id
                    } 
                    break;
                case 'planning': 
                    {
                        scope = 'planningById'
                        path = 'planning'
                        segment = item._id
                    } 
                    break;
                case 'planningById':
                    {
                        scope = 'planningGoalById'
                        path = 'planning'
                        segment = 'latest'
                        childrenId = item._id
                    } 
                    break;
                case 'logs':
                    {
                        scope = 'log'
                        path = 'logs'
                        segment = item._id
                    }
                    break;
            }
            
            this.loadRecords({ scope, path, segment, childrenId })
                .then(() => { this.tabActived = this.tabActived+1 }).catch(() => {})
            return
        },

        close () {
            this.dialog = false
            setTimeout(() => {
                this.reset()
			}, 300)
        },
        
        closeImport () {
            this.dialogImport = false
            setTimeout(() => {
                this.reset()
			}, 300)
        },

        save () {
            showLoading() 
            this.loading = true
            this.saveRecords({ scope: this.scope, arrayChilds: this.arrayChilds, path: this.path, payload: this.itemLoaded })
                .then((response) => { 
                    if (this.scope === 'diagnosis') {
                        this.loadRecords({ scope: 'diagnosisById', path: 'diagnosis', segment: response.data._id })
                            .then(() => {}).catch(() => {})
                    } else if (this.scope === 'planning') {
                        this.loadRecords({ scope: 'planningById', path: 'planning', segment: response.data._id })
                            .then(() => {}).catch(() => {})
                    } else if (this.scope === 'logs') {
                        this.loadRecords({ scope: 'log', path: 'logs', segment: response.data._id })
                            .then(() => {}).catch(() => {})
                    }

                    showSuccess(response, this.scope, this.mode) 
                    this.close()
                    this.rerenderTable() 
                    this.loading = false 
                })
                .catch((e) => { showError(e); this.loading = false  })
        },
        
        importRecords () {
            this.loading = true
            this.saveRecords({ scope: this.scope, arrayChilds: this.arrayChilds, path: this.path, payload: this.itemLoaded, importer: true })
				.then((response) => { 
                    showSuccess(response); 
                    this.closeImport(); 
                    this.rerenderTable() 
                    this.loading = false
                }).catch((e) => { showError(e); this.loading = false })
        },
        
		remove () {
            this.loading = true
            this.removeRecords({ scope: this.scope, arrayChilds: this.arrayChilds, path: this.path, payload: this.itemLoaded })
                .then((response) => { 
                    showSuccess(response); 
                    this.close(); 
                    this.rerenderTable() 
                    this.loading = false
                }).catch((e) => { showError(e); this.loading = false})
		},
        
		formProperty () {
			switch (this.mode) {
				case 'save':
                    this.formTitle = 'Novo Item'
                    this.formColor = 'primary'
					break;
				case 'edit':
                    this.formTitle = 'Editar Item'
                    this.formColor = 'warning'
                    break;
				case 'view':
                    this.formTitle = 'Ver Item'
                    this.formColor = 'success'
                    break;
                case 'remove':
                    this.formTitle = 'Excluir Item'
                    this.formColor = 'error'
                    break;
                default:
                    this.formTitle = 'Editar Item'
                    this.formColor = 'warning'
                    break;
			}
		},

		dynamicNestedObjects(item, key, options) {
            // console.log(item, key, options)
            if (typeof item === 'undefined') { return '' }
            if (Object.entries(item).length === 0 && item.constructor === Object && key === 'performance') { return 0 }
            if (Object.entries(item).length === 0 && item.constructor === Object) { return item }
            var obj = (options.hasOwnProperty('arrayParent')) ? item[options.arrayParent][item[options.arrayParent].length-1] : item
            key = key.split('.')
			
			while(key.length) {
                if(typeof obj !== 'object') return undefined
                if(Array.isArray(obj)) {
                    var array = []
                    obj.forEach((element) => {
                        array.push(element[key])
                    })
                    key.shift()
                    return array
                } else {
                    obj = obj[key.shift()]
                }
            }
            
            // Formating
            // if (options.dateFormat) { obj = moment(obj).format(options.dateFormat) }
            if (options.date) { obj = (obj) ? moment(obj).format("DD/MM/YYYY") : '' }
            if (options.dateHour) { obj = (obj) ? moment(obj).format("DD/MM/YYYY - HH:mm:ss") : '' }
            if (options.dateYear) { obj = (obj) ? moment(obj).format("YYYY") : '' }
            if (options.datePlusWeek) { obj = (obj) ? moment(obj).format("DD/MM/YYYY, dddd") : '' }
            if (options.slice) { obj = (obj) ? obj.slice(options.slice) : '' }
            if (options.toUpperCase) { obj = (obj) ? obj.toUpperCase() : '' }
            if (options.multiplier) { obj = (obj) ? obj * options.multiplier : '' }
            // if (options.currencyReal) { obj = obj.replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1.") }

			return obj
        },

        ganttObject(payload) {
            let obj = {}
            
            switch (this.scope) {
                case 'planningById':
                    {
                        const date = (payload.done) ? new Date(payload.period.endAt) : new Date()
                        const foreseenTo = new Date(payload.period.foreseenTo)
                        obj = {
                            done: {
                                text:   (payload.done) ? 'Concluída' : 'Em Aberto',
                                color:   (payload.done) ? 'green' : 'blue-grey lighten-4',
                            },
                            term: {
                                text:   (date > foreseenTo) ? 'Atrasado' : 'No Prazo',
                                color:   (date > foreseenTo) ? 'error' : 'success',
                            },
                        }
                    }
                    break;
                case 'planningGoalById':
                    {
                        const date = (payload.done) ? new Date(payload.period.endAt) : new Date()
                        const foreseenTo = new Date(payload.period.foreseenTo)
                        obj = {
                            done: {
                                text:   (payload.done) ? 'Concluída' : 'Em Aberto',
                                color:   (payload.done) ? 'green' : 'blue-grey lighten-4',
                            },
                            term: {
                                text:   (date > foreseenTo) ? 'Atrasado' : 'No Prazo',
                                color:   (date > foreseenTo) ? 'error' : 'success',
                            },
                            budget: {
                                text:   (payload.budget.accomplished > payload.budget.foreseen) ? 'Fora do Orçado' : 'Dentro do Orçado',
                                color:   (payload.budget.accomplished > payload.budget.foreseen) ? 'error' : 'success',
                            },
                        }
                    }
                    break;
            }
            
            return obj
        },
        
        performanceColor(performance) {
			let color = 'grey'

			if (performance <= 50) {
				color = 'error'
			} else if (performance <= 60) {
				color = 'warning'
			} else if (performance <= 80) {
				color = 'teal'
			} else if (performance <= 100) {
				color = 'success'
			}

			return color
        },
        performanceText(performance) {
			let text = ''
    
			if (performance <= 50) {
				text = 'Deficiente'
			} else if (performance <= 60) {
				text = 'Bom'
			} else if (performance <= 80) {
				text = 'Muito Bom'
			} else if (performance <= 100) {
				text = 'Excelente'
			}

			return text
        },

        checkSubHeaders(subheaders, item) {
            for (let i = 0; i < subheaders.length; i++) {
                const element = subheaders[i];
                if (item.hasOwnProperty(element.value)) { return true }
            }

            return false
        },

        eval(validation, item) { return eval(validation) },

        exportPdf ({ landscape = false, allFields = false, columns = []}) {
            const doc = new jsPDF({
                orientation: (!landscape) ? 'portrait' : 'landscape',
            });
            let headers = []
            let body = []

            if (!allFields && columns.length === 0) {
                headers = this.headers.filter(x => x.value !== 'actions').map(x => x.value)
                columns = this.headers.filter(x => x.value !== 'actions').map(x => { return { header: x.text, dataKey: x.value } })
            } else if (columns.length === 0) {
                headers = Object.keys(this.records[0]).filter(x => !(['_id', 'createdAt', 'modifiedAt', 'deletedAt', '__v'].indexOf(x) > -1))
                columns = headers.map(x => { return { header: x, dataKey: x } })
            }
            body = this.records.map(x => {
                const array = []
                columns.forEach(el => {
                    array.push(x[el.dataKey])
                })
                return array
            })
            
            let  size = { x: 210, y: 297 }
            if (landscape) { size = { x: 297, y: 210 } } 
            doc.setFontSize(20)
            doc.setFontStyle('bold')
            doc.text(this.title, size.x/2, 15, {align: 'center'});
            doc.autoTable({
                styles: {fontSize: 8},
                headStyles: {fontStyle: 'bold'}, 
                margin: {top: 25, right: 5, bottom: 10, left: 5},
                columns,
                columnStyles: {'email': {cellWidth: 50},'profession': {cellWidth: 50},},
                body
            })
            doc.save(`${this.title.toLowerCase()}.pdf`);
        },
        exportCsv (arrData) {
            let csvContent = "data:text/csv;charset=utf-8,";
            csvContent += [
                Object.keys(arrData[0]).join(";"),
                ...arrData.map(item => Object.values(item).join(";").replace(/\n/gm, ""))
            ].join("\n").replace(/(^\[)|(\]$)/gm, "");
            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", `${this.title.toLowerCase()}.csv`);
            link.click();
        },

        onCopy: function (e) {
            Vue.toasted.global.defaultSuccess({ msg: 'Copiado'})
        },
        onError: function (e) {
            Vue.toasted.global.defaultError({ msg: 'Falha ao copiar' }) 
        },
    },
    created() {
        this.initialize()
        this.reset()
    }
}
</script>

<style>
	/* .v-card__title { color: white; } */
    /* .v-progress-linear {
        text-align: center;
        color: black;
    } */
</style>